module.exports = __webpack_public_path__ + "static/profilefallback-fc5109a933d029975b799546749e16b0.png";